import { useAuth0 } from '@auth0/auth0-react';
import { QueryClient } from '@tanstack/react-query';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';

import { ToastsProvider } from '../cdl/Toast/ToastsProvider';
import { AdvancedError } from '../common/Error/AdvancedError';
import { NotFoundErrorPage } from '../common/Error/NotFoundErrorPage';
import { UnauthenticatedNotFoundErrorPage } from '../common/Error/UnauthenticatedNotFoundErrorPage';
import { ThemeProvider } from '../common/ThemeProvider';

const Root = () => {
    return (
        <ThemeProvider>
            <Outlet />
            <ToastsProvider />
        </ThemeProvider>
    );
};

const RootNotFoundComponent = () => {
    const { isAuthenticated } = useAuth0();

    if (isAuthenticated) {
        return <NotFoundErrorPage />;
    }

    return <UnauthenticatedNotFoundErrorPage />;
};

interface AppRouteContext {
    queryClient: QueryClient;
    auth: ReturnType<typeof useAuth0>;
}

export const Route = createRootRouteWithContext<AppRouteContext>()({
    component: Root,
    errorComponent: ({ error, reset }) => <AdvancedError error={error} resetError={reset} />,
    notFoundComponent: RootNotFoundComponent,
});
